var _defs, _polygon, _path, _polygon2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonaLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77.59 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #212529;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 .53 6.94 .53 10.29 14.6 10.35 14.6 13.8 .53 20.66 .53 20.66 19.47 16.2 19.47 16.2 4.76 16.14 4.76 12.39 19.47 8.22 19.47 4.36 4.76 4.31 4.76 4.31 19.47 0 19.47 0 .53"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.38,20c-6.04,0-9.57-4.68-9.57-10S25.34,0,31.38,0s9.57,4.68,9.57,10-3.54,10-9.57,10m0-16.01c-2.77,0-4.84,1.76-4.84,6.01,0,2.77,1.12,6.01,4.84,6.01,3.51,0,4.84-3.09,4.84-6.01s-1.33-6.01-4.84-6.01"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "42.2 .53 46.99 .53 53.87 12.63 53.93 12.63 53.93 .53 58.24 .53 58.24 19.47 53.5 19.47 46.56 7.55 46.51 7.55 46.51 19.47 42.2 19.47 42.2 .53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.55,.53h4.89l7.15,18.94h-5.08l-.96-2.98h-6.99l-.96,2.98h-5.05L65.55,.53Zm4.87,12.45l-2.34-7.82h-.05l-2.34,7.82h4.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonaLogoMobile);
export default __webpack_public_path__ + "static/media/Mona Logo Mobile.18d0e190b518b7dce8575cfbe10d7532.svg";
export { ForwardRef as ReactComponent };